import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Helmet } from 'react-helmet';
import { PromoPopupHandler } from './components/PromoPopupHandler';


ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <title>WaveMind Audio | Specialist in Guitar Software and Plugins</title>
      <link rel="canonical" href="https://wavemind.net/" />
    </Helmet>
    {/* <ReclameBanner /> */}
    <App />

    <PromoPopupHandler />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
